<template>
  <div
    class="meteo"
    :style="{
      '--top': isTotemAccessibility ? 'auto' : messageHeight,
      '--bottom': isTotemAccessibility ? '0px' : 'auto',
      '--sidebar-width': sidebarWidth,
      '--height': isTotemAccessibility ? '400px' : height
    }"
  >
    <div
      v-if="isTotemAccessibility"
      style="margin-top: -20px"
    >
      <center>
        <a
          @click="handleCloseAccessibility"
        >
          <div
            class="main-language-item"
          >
            <div class="language-item">
              <v-icon dark>mdi-close</v-icon>
            </div>
          </div>
        </a>
        <!-- <v-btn class="mx-2" fab dark small color="black"
          @click="handleCloseAccessibility"
        >
          <v-icon dark>mdi-close</v-icon>
        </v-btn> -->
      </center>
    </div>
    <table style="width: 100%;height:100%">
      <tr 
        v-if="isTotemAccessibility"
        style="height:50%"
      >
        <td> 
          <center class="label">
            {{ $t('totem.mobileVersion').toUpperCase() }}
          </center>
          <center>
            <v-img  
              v-if="isTotemAccessibility && qrImage && qrImage.length > 0"
              :src="qrImage"
              :lazy-src="qrImage"
              class="grey lighten-2"
              width="150px"
              height="auto"
              style="margin-top: 10px;"
            />
          </center>
          <v-divider dark style="margin-top:15px;"/>
        </td>
      </tr>
      <tr
        :style="{ 'height': isTotemAccessibility ? '25%' : '50%' }"
      >
        <td> 
          <meteo />
        </td>
      </tr>
      <tr :style="{ 'height': isTotemAccessibility ? '25%' : '50%' }">
        <td>
          <languages />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import QRCode from 'qrcode'
import constants from '@/constants'
import Meteo from './Meteo'
import Languages from './Languages'
export default {
  components: {
    Meteo,
    Languages
  },
  data: () => ({
    qrImage: '',
  }),
  computed: {
    ...mapState('app',['isTotemAccessibility']),
    url () {
      return window.location.href.split('#')[0]
    },
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.meteo.height + 'px'
    },
    messageHeight() {
      return constants.totem.messages.height + 'px'
    }
  },
  mounted () {
    this.handleCreateQR()
  },
  methods: {
    handleCreateQR () {
      QRCode.toDataURL(this.url, {
        type: 'image/png',
        width: 344,
        color: {
          dark: '#000000',  // Blue dots
          light: '#FFFFFF'
        }
      })
      .then(url => {
        this.qrImage = url
      })
      .catch(err => {
        console.error(err)
      })
    },
    handleCloseAccessibility () {
      this.$store.state.app.isTotemAccessibility = false
    }
  }
}
</script>

<style scoped>
  .meteo {
    position: fixed;
    bottom: var(--bottom);
    top: var(--top);

    background-color: rgba(0,0,0,.6);
    width: var(--sidebar-width);
    height: var(--height);
    border-radius: 0px 10px 10px 0px;
    mix-blend-mode: multiply;
  }
  .main-language-item {
    background: linear-gradient(300deg, rgba(0,0,0,.5), transparent);
    padding: 4px;
    border-radius: 50%;
    margin: 2px;
    width: 50px;
  }
    .language-item {
    border-radius: 100%;
    padding: 10px 12px 10px 12px;
    /* background-color: rgba(0, 0, 0, 0.31); */
    color: white;
    border: 0.5px solid rgba(0, 0, 0, 0.29);; 
    background-color: rgba(0,0,0,.31);
  }
</style>
